import Image from 'next/image'
import React from 'react'

import bgImage from '@/assets/images/top/bg_grd.jpg'
import Heading from '@/components/Heading'
import '@/components/Layout/Footer/Atoms/FooterInfoLinkItem/FooterInfoLinkItem.scss'
import '@/components/Layout/Footer/Molecules/FooterGenreLinks/FooterGenreLinks.scss'
import '@/components/Layout/Footer/Molecules/FooterInfoLinks/FooterInfoLinkItem.scss'
import '@/components/Layout/Footer/Organisms/BackToTop/BackToTop.scss'
import '@/components/Layout/Footer/Organisms/Footer/Footer.scss'
import '@/components/Layout/Footer/Organisms/FooterLinksUnion/FooterLinksUnion.scss'
import Header from '@/components/Layout/Header/Organisms/Header'
import '@/components/Layout/HeaderFooterCommon/Atoms/SlidingTextLink/ProductLinkItem.scss'
import LenisLayout from '@/components/Layout/LenisLayout'
import ULink from '@/components/Link/ULink'
import '@/components/Page/CustomError/CustomError.scss'

type Props = {
  headingText: string
  text: string
  header?: boolean
  nextLink?: boolean
}

export default function CustomError({ headingText, text, header = true, nextLink = true }: Props) {
  return (
    <>
      {header && <Header nextLink={nextLink} staticComponent={true} />}
      <LenisLayout>
        <div className="u-main">
          <div className="c-notFound">
            <Image className="c-notFound__bgImage" src={bgImage.src} fill={true} alt="" />
            <div className="c-notFound__content">
              <Heading className="c-notFound__content--heading" headingType="h2" fontFamily="neue">
                {headingText}
              </Heading>

              <p className="c-notFound__content--text u-font-yu-min">{text}</p>

              <ULink nextLink={false} href="/" className="c-notFound__content--link u-mo-crop u-mo-line u-font-neue">
                <div className="u-mo-crop__container u-mo-line__text">
                  <span className="u-mo-crop__text u-mo-crop__text--inner">Back to Top</span>
                  <span className="u-mo-crop__text u-mo-crop__text--outer">Back to Top</span>
                </div>
              </ULink>
            </div>
          </div>
        </div>
      </LenisLayout>
    </>
  )
}
